import { render } from "./SupplierAdd.vue?vue&type=template&id=f6d85f12"
import script from "./SupplierAdd.vue?vue&type=script&lang=js"
export * from "./SupplierAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__